import { render } from "./FightIcon.vue?vue&type=template&id=ba96cd44&scoped=true"
const script = {}

import "./FightIcon.vue?vue&type=style&index=0&id=ba96cd44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba96cd44"]])

export default __exports__